import {
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from "@angular/core";
import { CustomerPointsService } from "../../master-services/customer-points/customer-points.service";
import { ICustomerPoints, ICustomerPointsDetails, SpendCustomerPoints } from "../../master-models/customer-points.model";
import { RestService } from "../../master-services/Rest/rest.service";
import swal from "sweetalert2";
import { CUSTOMER_POINTS_STATES } from "../../constants/customer-points-states";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-master-customer-points",
  templateUrl: "./master-customer-points.component.html",
  styleUrls: [
    "./master-customer-points.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterCustomerPointsComponent implements OnInit {
  customers = [];
  selectedCustomer = null;
  customerPoints: ICustomerPoints[] = [];
  customerPointsDetails: ICustomerPointsDetails;
  selectedStatus = '';
  pointStates = CUSTOMER_POINTS_STATES;
  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  considerDate = false;

  constructor(
    private customerPointsService: CustomerPointsService,
    private restService: RestService,
  ) {}

  ngOnInit() {
    this.getCustomers();
  }

  calculateCustomerPointsDetails() {
    this.customerPointsDetails = {
      expired: 0,
      available: 0,
      total: 0,
      spent: 0
    };
    
    this.customerPoints.forEach(points => {
      if (points.canceled === 0) {
        if (points.expired === 1) {
          this.customerPointsDetails.expired += (points.amount - points.amount_spent);
        } else {
          this.customerPointsDetails.available += (points.amount - points.amount_spent);
        }

        this.customerPointsDetails.total += points.amount;
        this.customerPointsDetails.spent += points.amount_spent;
      }
    });
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate && this.fromDate) {
      const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

      if (fromD > untilD) {
        this.untilDate = { ...this.fromDate };
      }

      if (this.considerDate && this.fromDate && this.untilDate) {
        this.getCustomerPoints();
      }
    }
  }

  onDateSelectionUntil(date: any) {
    if (this.fromDate && this.untilDate) {
      const fromD = new Date(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      const untilD = new Date(this.untilDate.year, this.untilDate.month, this.untilDate.day);

      if (untilD < fromD) {
        this.fromDate = { ...this.untilDate };
      }

      if (this.considerDate && this.fromDate && this.untilDate) {
        this.getCustomerPoints();
      }
    }
  }

  changeConsiderDate(event) {
    this.considerDate = !this.considerDate;
    this.getCustomerPoints();
  }

  cancelPoints(id: number) {
    swal({
      title: 'Deseas cancelar estos puntos?',
      text: 'Esta accion no se puede deshacer.',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
    }).then(res => {
      if (res.value) {
        swal({
          title: "Guardando información ...",
          allowOutsideClick: false,
        });
        this.customerPointsService.cancelPoints(id)
          .subscribe({
            next: res => {
              this.getCustomerPoints();
              swal.close();
            },
            error: e => {
              swal.close();
              swal({
                title: 'Error al cancelar',
                text: 'No se pudo completar el proceso. Intente nuevamente.',
                type: 'error',
              });
            }
          });
      }
    });
  }

  getCustomerPoints() {
    let fromDateStr = '';
    let untilDateStr = '';

    if (this.considerDate && this.fromDate && this.untilDate) {
      fromDateStr = `${this.fromDate.year}-${String(this.fromDate.month).padStart(2, '0')}-${String(this.fromDate.day).padStart(2, '0')}`;
      untilDateStr = `${this.untilDate.year}-${String(this.untilDate.month).padStart(2, '0')}-${String(this.untilDate.day).padStart(2, '0')}`;
    }

    this.customerPointsService.getCustomerPoints(this.selectedCustomer, this.selectedStatus, fromDateStr, untilDateStr)
      .subscribe(res => {
        this.customerPoints = res.data;
        console.log(this.customerPoints);
        this.calculateCustomerPointsDetails();
      });
  }

  getCustomers() {
    this.restService.getCustomers()
      .then(data => {
        const resp: any = data;
        this.customers = resp.data;
        console.log(this.customers);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-customer-points/master-customer-points.component.ts